import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core/utils';
import angular, { IFilterService, IScope } from 'angular';

DashboardUserController.$inject = ['$scope', '$filter', 'AuthService', 'ApiService', 'CalendarService'];

function DashboardUserController(
  $scope: IScope & { dashboardUser: TODO },
  $filter: IFilterService,
  AuthService: TODO,
  ApiService: ApiService,
  CalendarService: TODO
) {
  const ctrl = {
    model: {
      unconfirmed: 0,
      visitors: 256,
      nextStartTime: '',
      startTime: '',
      endTime: '',
      ownerId: '',
      events: [],
    } as TODO,

    events: [
      {
        id: '53a4b77d3004d56f7586554e',
        name: 'Byzantine Sculpture',
        resourceType: 'Docent',
        startTime: '2014-06-22T09:00:00-07:00',
        endTime: '2014-06-22T10:00:00-07:00',
        location: 'Room 1A',
        status: 'pending',
      },
      {
        id: '53a4b77d3004d56f7586554e',
        name: 'Byzantine Sculpture',
        resourceType: 'Docent',
        startTime: '2014-06-22T09:00:00-07:00',
        endTime: '2014-06-22T10:00:00-07:00',
        location: 'Room 1A',
        status: 'pending',
      },
      {
        id: '53a4b77d3004d56f7586554e',
        name: 'Byzantine Sculpture',
        resourceType: 'Docent',
        startTime: '2014-06-22T09:00:00-07:00',
        endTime: '2014-06-22T10:00:00-07:00',
        location: 'Room 1A',
        status: 'pending',
      },
      {
        id: '53a4b77d3004d56f7586554e',
        name: 'Byzantine Sculpture',
        resourceType: 'Docent',
        startTime: '2014-06-22T09:00:00-07:00',
        endTime: '2014-06-22T10:00:00-07:00',
        location: 'Room 1A',
        status: 'pending',
      },
      {
        id: '53a4b77d3004d56f7586554e',
        name: 'Byzantine Sculpture',
        resourceType: 'Docent',
        startTime: '2014-06-22T09:00:00-07:00',
        endTime: '2014-06-22T10:00:00-07:00',
        location: 'Room 1A',
        status: 'pending',
      },
    ],

    selectedEvents: [] as string[],

    init: function () {
      const d = new Date();
      const startTime = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0);
      const endTime = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, 0);

      $scope.$emit('Application::contentTitleChange', {});
      ctrl.model.ownerId = AuthService.getCookie('user').id;
      ctrl.model.startTime = CalendarService.toISO8601(startTime);
      ctrl.model.endTime = CalendarService.toISO8601(endTime);
      ctrl.getEvents();
    },

    getEvents: function () {
      ApiService.entity.schedules
        .owner({
          ownerId: ctrl.model.ownerId,
          startTime: ctrl.model.startTime,
          endTime: ctrl.model.endTime,
        })
        .then((response) => ctrl.success.getEvents(response))
        .catch((response) => ctrl.error.getEvents(response));
    },

    getNextEventTime: function () {},

    getUnconfirmedEvents: function () {},

    getTotalVisitors: function () {},

    isChecked: function (id) {
      let r: number | false = false;

      for (let i = 0, ii = ctrl.selectedEvents.length; i < ii; i++) {
        if (ctrl.selectedEvents[i] === id) {
          r = i;
          break;
        }
      }

      return r;
    },

    updateMetrics: function () {
      const currentTime = new Date();
      let eventTime: string | false = false;

      for (let i = 0, ii = ctrl.model.events.length; i < ii; i++) {
        const startTime = new Date(ctrl.model.events[i].startTime);
        if (!eventTime && startTime >= currentTime) {
          eventTime = $filter('date')(startTime, 'h:mma');
        }
        if (ctrl.model.events[i].rsvpState) {
          ctrl.model.unconfirmed++;
        }
      }

      ctrl.model.nextStartTime = eventTime;

      return eventTime;
    },

    toggleEventSelection: function (index) {
      const checkedIndex = ctrl.isChecked(ctrl.events[index].id);

      if (checkedIndex !== false) {
        ctrl.selectedEvents.splice(checkedIndex, 1);
      } else {
        ctrl.selectedEvents.push(ctrl.events[index].id);
      }
    },

    success: {
      getEvents: function (response) {
        ctrl.model.events = response.data.payload;
        ctrl.updateMetrics();
      },
    },

    error: {
      getEvents: function (response) {},
    },
  };

  $scope.dashboardUser = ctrl;
  ctrl.init();
}

export const DashboardUserControllerModule = angular
  .module('acme.view.application.dashboard.user.controllers', [
    'acme.common.service.auth',
    'acme.common.service.calendar',
  ])
  .controller('DashboardUserController', DashboardUserController).name;
